var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBcuFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1723.4 456.51",
    style: {
      enableBackground: "new 0 0 1723.4 456.51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000051375221450619998640000014031234823364230075_);}\n\t.st2{fill:url(#SVGID_00000098179340522504064180000013452368530527278977_);}\n\t.st3{fill:url(#SVGID_00000115480295785063931180000010197486148505697429_);}\n\t.st4{fill:url(#SVGID_00000098904942194531650320000013438850603411806594_);}\n\t.st5{fill:url(#SVGID_00000168829185033115117180000016629165284370760869_);}\n\t.st6{fill:url(#Trac\xE9_317_00000105389882488538740210000007168204406138608562_);}\n\t.st7{fill:#1A1A1A;}\n\t.st8{fill:url(#SVGID_00000152253329452728447830000015880725889101085099_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "cercle_droit"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.5876,
    y1: 219.6983,
    x2: 352.3059,
    y2: 219.6983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001999733,
    style: {
      stopColor: "#56E123"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#64EA02"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.29,218.91c0.44,10.66-7.89,19.68-18.55,20.12c-10.66,0.44-19.7-7.87-20.14-18.53 c-0.44-10.66,7.89-19.7,18.55-20.14C342.81,199.93,351.83,208.25,352.29,218.91z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "oval_bas"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104686234499948179820000001945663043281760651_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.0799,
    y1: 299.6686,
    x2: 307.6412,
    y2: 299.6686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001999733,
    style: {
      stopColor: "#2AC489"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#50DD30"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104686234499948179820000001945663043281760651_)"
    },
    d: "M301.48,254.44l-0.51-0.47 c-3.74-3.45-8.64-5.24-13.77-5.02c-5.11,0.22-9.84,2.39-13.29,6.13l-57.78,62.77c-7.16,7.76-6.65,19.9,1.11,27.04l0.51,0.47 c7.76,7.16,19.9,6.65,27.04-1.11l57.8-62.77C309.73,273.72,309.24,261.58,301.48,254.44z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cercle_gauche"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001642641878947127960000004364909667370919299_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.7529,
    y1: 286.2331,
    x2: 201.4716,
    y2: 286.2331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001999466,
    style: {
      stopColor: "#15B5BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23BF9A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001642641878947127960000004364909667370919299_)"
    },
    d: "M181.32,266.89 c-10.66,0.44-18.99,9.47-18.55,20.14c0.22,5.17,2.43,9.93,6.23,13.44c3.82,3.51,8.74,5.31,13.91,5.11 c10.66-0.44,18.99-9.47,18.55-20.14C201.02,274.78,191.98,266.45,181.32,266.89z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "oval_centre"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182506537399454368400000014227229964412733329_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.4104,
    y1: 206.287,
    x2: 303.979,
    y2: 206.287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001999599,
    style: {
      stopColor: "#29C28D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4FDC33"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182506537399454368400000014227229964412733329_)"
    },
    d: "M297.81,161.04l-0.51-0.47 c-3.74-3.43-8.64-5.22-13.75-5c-5.13,0.2-9.86,2.39-13.29,6.13l-57.8,62.77c-7.16,7.76-6.65,19.88,1.11,27.04l0.51,0.47 c7.76,7.16,19.9,6.65,27.04-1.11l57.8-62.77C306.08,180.32,305.57,168.2,297.81,161.04z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "oval_gauche"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145034500994104780580000013460145007163185039_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.1273,
    y1: 210.4006,
    x2: 210.6952,
    y2: 210.4006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001999733,
    style: {
      stopColor: "#00A7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#28C28F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145034500994104780580000013460145007163185039_)"
    },
    d: "M204.52,165.17l-0.51-0.47 c-3.74-3.45-8.62-5.22-13.75-5.02c-5.13,0.22-9.84,2.39-13.29,6.13l-57.8,62.77c-7.14,7.78-6.65,19.9,1.11,27.06l0.51,0.47 c7.78,7.14,19.9,6.65,27.06-1.13l57.78-62.77C212.79,184.44,212.3,172.32,204.52,165.17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cercle_haut"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015350099999494874130000002478733523618786189_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.6458,
    y1: 130.4333,
    x2: 255.3464,
    y2: 130.4333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001999733,
    style: {
      stopColor: "#2CC584"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3BCE63"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015350099999494874130000002478733523618786189_)"
    },
    d: "M235.19,111.09 c-10.66,0.44-18.97,9.47-18.53,20.14c0.44,10.66,9.48,18.99,20.14,18.55c10.66-0.44,18.97-9.47,18.53-20.14 C254.89,118.98,245.85,110.65,235.19,111.09z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "contour"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trac\\xE9_317_00000034055317996705040210000004495246219814758567_",
    gradientUnits: "userSpaceOnUse",
    x1: -62.8153,
    y1: 479.2949,
    x2: -60.0382,
    y2: 479.2949,
    gradientTransform: "matrix(145.9987 0 0 -146.0023 9201.4316 70209.2266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001999733,
    style: {
      stopColor: "#00A7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#78C939"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_317",
    style: {
      fill: "url(#Trac\xE9_317_00000034055317996705040210000004495246219814758567_)"
    },
    d: "M435.77,222.7 c-4.61-111.87-99.03-198.82-210.9-194.21C113,33.1,26.05,127.53,30.66,239.39c4.61,111.86,99.03,198.81,210.89,194.21 C353.37,428.86,440.24,334.52,435.77,222.7z M240.59,410.05c-98.86,4.07-182.3-72.77-186.37-171.62s72.77-182.3,171.62-186.37 c98.85-4.07,182.29,72.76,186.37,171.61C416.18,322.49,339.4,405.87,240.59,410.05L240.59,410.05z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1505.32,279.04c-7.78,0-14.85-1.21-21.2-3.62c-6.35-2.41-11.78-5.81-16.27-10.19 c-4.49-4.38-7.97-9.7-10.44-15.94c-2.47-6.25-3.7-13.2-3.7-20.87v-60.15c0-6.35,5.15-11.5,11.5-11.5h0c6.35,0,11.5,5.15,11.5,11.5 v60.03c0,6.02,0.99,10.99,2.96,14.93c1.97,3.94,4.41,7.06,7.31,9.35c2.9,2.3,6.02,3.89,9.37,4.76c3.34,0.87,6.33,1.31,8.96,1.31 c2.63,0,5.61-0.44,8.96-1.31c3.34-0.87,6.46-2.46,9.37-4.76c2.9-2.29,5.34-5.41,7.31-9.35c1.97-3.94,2.96-8.92,2.96-14.93v-60.03 c0-6.35,5.15-11.5,11.5-11.5l0,0c6.35,0,11.5,5.15,11.5,11.5v60.15c0,7.67-1.21,14.63-3.62,20.87 c-2.41,6.25-5.86,11.56-10.35,15.94c-4.49,4.38-9.92,7.78-16.27,10.19C1520.33,277.84,1513.21,279.04,1505.32,279.04z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1038.35,251.58c-3.58-3.77-9.26-4.2-13.64-1.4c-4.56,2.91-11.16,5.77-19.72,5.77 c-5.64,0-10.91-1.16-15.82-3.47c-4.91-2.31-9.17-5.39-12.78-9.22c-3.61-3.83-6.48-8.29-8.63-13.37 c-2.14-5.08-3.21-10.43-3.21-16.07c0-5.52,1.07-10.85,3.21-15.99c2.14-5.13,5.02-9.61,8.63-13.45c3.61-3.83,7.87-6.91,12.78-9.22 c4.91-2.31,10.18-3.47,15.82-3.47c7.54,0,14.35,2.93,19.26,5.87c4.68,2.8,10.61,2.18,14.37-1.77l0,0 c5.15-5.43,3.8-14.25-2.77-17.85c-7.58-4.15-18.23-8.23-30.86-8.23c-8.8,0-17.09,1.69-24.87,5.07 c-7.78,3.39-14.58,7.98-20.38,13.79c-5.81,5.81-10.41,12.61-13.79,20.39c-3.38,7.78-5.08,16.07-5.08,24.87 c0,8.8,1.69,17.09,5.08,24.87c3.38,7.78,7.98,14.58,13.79,20.38c5.81,5.81,12.6,10.4,20.38,13.79c7.78,3.39,16.07,5.08,24.87,5.08 c12.8,0,23.92-4.48,31.68-8.82c6.06-3.4,7.42-11.49,2.64-16.53L1038.35,251.58z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.07,229.68c0-7.2,1.29-13.74,3.89-19.62c2.59-5.87,6.1-10.9,10.52-15.07c4.42-4.17,9.67-7.39,15.74-9.67 c6.07-2.28,12.51-3.41,19.34-3.41c6.83,0,13.27,1.14,19.34,3.41c6.07,2.27,11.31,5.5,15.74,9.67c4.42,4.17,7.93,9.2,10.52,15.07 c2.59,5.88,3.89,12.42,3.89,19.62c0,7.2-1.3,13.78-3.89,19.72c-2.59,5.94-6.1,11.03-10.52,15.26c-4.43,4.24-9.67,7.55-15.74,9.96 c-6.07,2.4-12.51,3.6-19.34,3.6c-6.82,0-13.27-1.2-19.34-3.6c-6.07-2.4-11.31-5.72-15.74-9.96c-4.43-4.23-7.93-9.32-10.52-15.26 C600.36,243.46,599.07,236.88,599.07,229.68z M622.2,229.68c0,3.54,0.54,7.08,1.61,10.62c1.07,3.54,2.68,6.7,4.83,9.48 c2.15,2.78,4.86,5.06,8.15,6.83c3.28,1.77,7.2,2.66,11.75,2.66c4.55,0,8.47-0.89,11.76-2.66c3.28-1.77,6-4.04,8.15-6.83 c2.15-2.78,3.76-5.94,4.83-9.48c1.07-3.54,1.61-7.08,1.61-10.62c0-3.54-0.54-7.04-1.61-10.52c-1.08-3.47-2.69-6.6-4.83-9.38 c-2.15-2.78-4.87-5.02-8.15-6.73c-3.29-1.7-7.21-2.56-11.76-2.56c-4.55,0-8.47,0.85-11.75,2.56c-3.29,1.71-6,3.95-8.15,6.73 c-2.15,2.78-3.76,5.91-4.83,9.38C622.73,222.63,622.2,226.14,622.2,229.68z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1427.26,258.87l-52.57-45.23v-67.45c0-6.32-5.15-11.43-11.47-11.38c-6.24,0.05-11.28,5.13-11.28,11.38v120.72 c0,6.28,5.1,11.37,11.38,11.37c6.28,0,11.37-5.09,11.37-11.37v-23.34l36.48,31.39c4.42,4.42,11.57,4.45,16.02,0.06 C1431.7,270.59,1431.73,263.34,1427.26,258.87z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1329.56,247.58c-3.08,0-5.79,1.36-7.72,3.46c-0.02,0.01-0.14-0.04-0.14-0.02c-1.79,2.22-4.1,4.29-7.38,6.06 c-3.29,1.77-7.21,2.66-11.76,2.66c-4.55,0-8.47-0.89-11.75-2.66c-3.29-1.77-6-4.04-8.16-6.83c-2.15-2.78-3.76-5.94-4.83-9.48 c-1.08-3.53-1.61-7.07-1.61-10.61s0.54-7.05,1.61-10.53c1.07-3.47,2.69-6.6,4.83-9.38c2.15-2.77,4.86-5.02,8.16-6.73 c3.28-1.7,7.2-2.55,11.75-2.55c4.55,0,8.47,0.85,11.76,2.55c3.28,1.71,5.07,3.01,7.22,5.79c0.01,0.02,0.12,0,0.15,0.01 c1.93,2.21,4.7,3.68,7.87,3.68c5.84,0,10.57-4.73,10.57-10.57c0-2.88-1.17-5.47-3.03-7.38l0.02-0.02 c-0.02-0.02-0.05-0.03-0.06-0.05c-0.05-0.05-0.12-0.08-0.17-0.13c-4.27-3.85-9.24-6.9-14.98-9.05c-6.06-2.28-12.51-3.41-19.34-3.41 c-6.82,0-13.27,1.13-19.33,3.41s-11.31,5.5-15.73,9.67c-4.43,4.17-7.93,9.2-10.52,15.08c-2.59,5.87-3.89,12.41-3.89,19.62 c0,7.2,1.29,13.78,3.89,19.71c2.59,5.94,6.09,11.02,10.52,15.26c4.42,4.24,9.67,7.56,15.73,9.95c6.07,2.4,12.51,3.6,19.33,3.6 c6.83,0,13.28-1.21,19.34-3.6c5.74-2.27,10.71-5.39,14.99-9.3l-0.04-0.05c2.01-1.92,3.28-4.6,3.28-7.6 C1340.13,252.31,1335.4,247.58,1329.56,247.58z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1094.03,184.2c-6.42,0.34-12.36,2.24-17.63,5.25v-8.67c0.01,0,0.01,0,0.02-0.01v-35.41 c0-6.26-5.14-11.3-11.39-11.18c-6.09,0.11-10.97,5.09-10.97,11.18v53.13c0.02-0.03,0.04-0.06,0.06-0.09v28.98 c-0.01,0.47-0.06,0.93-0.06,1.39v37.89c0,6.33,5.14,11.47,11.47,11.47h0c6.33,0,11.47-5.14,11.47-11.47V226.5h0.01 c0-0.04,0.01-0.08,0.01-0.12c0-0.08-0.01-0.16-0.01-0.24c0.13-10.56,8.71-19.09,19.31-19.09c10.67,0,19.33,8.65,19.33,19.33h-0.02 v40.28c0,6.33,5.14,11.47,11.47,11.47h0c6.33,0,11.47-5.14,11.47-11.47v-40.28v0C1138.55,202.3,1118.39,182.92,1094.03,184.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1680.7,210.51c-2.57-5.94-6.05-11.03-10.44-15.26c-4.4-4.23-9.6-7.55-15.63-9.95 c-5.53-2.2-11.39-3.35-17.56-3.53c-0.55-0.02-1.08-0.07-1.63-0.07c-0.23,0-0.45,0.03-0.68,0.03l0.02-0.04 c-12.23,0-21.95,4.47-28.21,8.47c-0.89,0.57-1.71,1.13-2.46,1.67c-2.18-2.87-5.09-5.14-8.76-6.81c-3.58-1.62-8.25-2.42-13.88-2.49 c0.03-0.03,0.02-0.07,0.05-0.1h-7.19c-5,0-9.05,4.15-9.05,9.26c0,5.11,4.05,9.26,9.05,9.26h0.69c4.61,0.12,7.72,1.36,9.09,3.88 c1.44,2.66,2.17,6,2.17,10.05V317.3c0,6.19,4.99,11.2,11.13,11.18c0.65,0,1.28-0.09,1.9-0.2c5.21-0.93,9.17-5.48,9.17-10.99v-46.46 c1.26,0.75,2.56,1.45,3.91,2.09c1.24,0.6,2.51,1.15,3.83,1.65c6.02,2.28,12.42,3.42,19.2,3.42c0.66,0,1.3-0.06,1.95-0.08 c6.05-0.2,11.81-1.28,17.24-3.33c6.02-2.27,11.23-5.49,15.63-9.67c4.39-4.17,7.87-9.2,10.44-15.07c2.57-5.88,3.86-12.42,3.86-19.62 C1684.56,223.02,1683.28,216.45,1680.7,210.51z M1635.44,259.42c-4.52,0-8.41-0.85-11.67-2.56c-3.26-1.71-5.96-3.95-8.1-6.73 c-2.13-2.78-3.73-5.91-4.8-9.38c-0.36-1.18-0.84-3.52-0.84-5.79v-17.49c0-6.28,11.27-16.9,24.59-16.9c0.35,0,0.6,0.06,0.91,0.09 c0.21,0,0.39,0.03,0.6,0.03c4.21,0.09,7.88,0.95,10.97,2.62c3.26,1.76,5.96,4.04,8.09,6.83c2.14,2.77,3.74,5.93,4.8,9.47 c1.07,3.54,1.61,7.08,1.61,10.62c0,3.53-0.54,7.04-1.61,10.53c-1.06,3.47-2.66,6.6-4.8,9.38c-2.13,2.78-4.83,5.02-8.09,6.73 c-2.78,1.45-6.03,2.25-9.72,2.46C1636.74,259.36,1636.11,259.42,1635.44,259.42z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M821.27,259.1h-0.21v-0.01c-0.02,0.01-0.04,0.01-0.06,0.01h-1.46c-4.82-0.07-8.01-1.35-9.42-3.93 c-1.45-2.65-2.18-6-2.18-10.05v-102.5c0-6.16-4.98-11.17-11.14-11.18c-6.19-0.02-11.22,4.99-11.22,11.18v46.53 c-2.43-1.44-5.02-2.7-7.8-3.75c-6.06-2.28-12.51-3.41-19.33-3.41c-6.83,0-13.27,1.13-19.33,3.41c-6.07,2.28-11.31,5.5-15.74,9.67 c-4.42,4.17-7.93,9.2-10.52,15.08c-2.59,5.87-3.89,12.41-3.89,19.62c0,7.2,1.29,13.78,3.89,19.72c2.59,5.94,6.1,11.02,10.52,15.26 c4.43,4.24,9.67,7.56,15.74,9.95c6.06,2.4,12.51,3.6,19.33,3.6c1.16,0,2.33-0.06,3.49-0.16c5.54-0.34,10.83-1.46,15.84-3.45 c1.11-0.44,2.17-0.92,3.21-1.43c3.65-1.56,6.82-3.29,9.17-4.9c2.18,2.78,5.05,4.99,8.66,6.61c3.79,1.71,8.72,2.56,14.79,2.56 c0.3,0,0.73-0.02,1.07-0.03h6.59c5.09,0,9.2-4.12,9.2-9.21C830.48,263.22,826.36,259.1,821.27,259.1z M770.2,256.68 c-3.29,1.77-7.2,2.66-11.75,2.66c-4.55,0-8.47-0.89-11.75-2.66c-3.29-1.77-6-4.04-8.15-6.83c-2.15-2.78-3.76-5.94-4.83-9.48 c-1.08-3.53-1.62-7.07-1.62-10.61s0.54-7.05,1.62-10.53c1.07-3.47,2.68-6.6,4.83-9.38c2.15-2.77,4.86-5.02,8.15-6.73 c3.29-1.7,7.2-2.55,11.75-2.55c4.55,0,8.47,0.85,11.75,2.55c3.29,1.71,6,3.96,8.16,6.73c2.15,2.79,3.76,5.92,4.83,9.38 c0.36,1.18,0.85,3.52,0.85,5.79c0,3.8,0.01,7.62-0.6,11.38c-0.56,3.52-1.85,6.97-3.44,10.15 C777.83,250.91,774.49,254.38,770.2,256.68z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M576.84,214.58c-1.61-1.81-3.95-3.21-6.62-4.33c0.47,0.18,2.77-6.98,2.96-7.67 c2.97-10.56,1.61-23.58-4.74-32.7c-6.88-9.88-18.94-13.2-30.46-13.2h-31.65c-6.53,0-11.82,5.29-11.82,11.82v97.91 c0,6.53,5.29,11.82,11.82,11.82h44.31c5.2,0,10.1-0.61,14.7-1.82c4.59-1.21,8.61-3.23,12.04-6.04c3.43-2.82,6.14-6.52,8.13-11.1 c1.99-4.58,2.99-10.18,2.99-16.81C588.5,233.74,585.4,222.36,576.84,214.58z M550.64,257.64h-30.6c-1.26,0-2.28-1.02-2.28-2.28 c0,0,0-28.61,0.03-28.61c0,0,0-20.59-0.03-20.59v-26.62c0-1.26,1.02-2.28,2.28-2.28h17.95c1.66,0,3.24,0.39,4.73,1.17 c1.49,0.78,2.8,1.78,3.9,3c1.21,1.34,2.08,2.86,2.66,4.47c2.82,6.18,3.04,13.78-1.51,20.25h-8.51h-2.12 c-5.71,0-10.34,4.65-10.29,10.37c0.04,5.66,4.64,10.22,10.29,10.22h11.01c5.31,0,17.1-0.02,17.1,14.45 C565.26,257.17,552.64,257.64,550.64,257.64z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M915.77,262.52c-2.01-4.57-4.6-8.61-7.72-12.16c-1.88-2.94-4.07-5.67-6.6-8.06 c4.85-4.63,8.59-10.38,10.8-16.86c0.11-0.32,0.23-0.63,0.34-0.94c0.1-0.32,0.19-0.64,0.28-0.96c1.16-3.83,1.81-7.87,1.82-12.08 v-19.42c0-6.34-5.13-11.47-11.47-11.47c-4.85,0-8.97,3.02-10.65,7.28c-0.62,1.41-0.97,2.96-0.97,4.6c0,0,0,19.42,0.02,19.42 c-0.01,2.16-0.39,4.22-1.05,6.14c-3.53,10.24-15.29,15.45-25.2,11.25c-5.21-2.21-9.59-6.57-11.34-12c-0.6-1.87-0.9-3.83-0.89-5.79 v-19.42c0-6.34-5.13-11.47-11.47-11.47c-6.33,0-11.47,5.13-11.47,11.47c0,0,0,19.29-0.01,19.37c0,11.85,4.92,22.51,12.79,30.15 c4.14,4.02,9.1,7.18,14.5,9.22c2.11,0.8,4.27,1.43,6.47,1.9c2.08,0.45,3.98,0.53,6.1,0.61c7.85,0.32,15.06,2.49,20.04,8.92 c2.15,2.79,3.76,5.92,4.83,9.38c1.08,3.48,1.61,6.99,1.61,10.53s-0.54,7.08-1.61,10.61c-1.07,3.54-2.69,6.7-4.83,9.48 c-2.15,2.78-4.86,5.06-8.16,6.83c-3.28,1.77-7.2,2.66-11.75,2.66c-4.43,0-8.25-0.86-11.49-2.53c-0.09-0.05-0.19-0.08-0.27-0.12 c-3.28-1.77-5.59-3.84-7.38-6.06c-0.01-0.01-0.12,0.03-0.14,0.02c-1.93-2.1-4.64-3.46-7.72-3.46c-5.84,0-10.57,4.73-10.57,10.57 c0,3,1.28,5.67,3.25,7.64c4.27,3.91,9.25,7.03,14.99,9.3c6.06,2.4,12.51,3.6,19.34,3.6c6.82,0,13.27-1.21,19.33-3.6 c6.07-2.4,11.31-5.71,15.73-9.95c4.43-4.23,7.93-9.31,10.52-15.26c2.59-5.94,3.89-12.51,3.89-19.72 C919.65,274.93,918.36,268.39,915.77,262.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136390597160832849550000007184408175811997091_",
    gradientUnits: "userSpaceOnUse",
    x1: 1386.453,
    y1: 189.0749,
    x2: 1432.5642,
    y2: 189.0749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001999733,
    style: {
      stopColor: "#00A7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#78C939"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136390597160832849550000007184408175811997091_)"
    },
    d: "M1429.46,169.37l-0.24-0.24 c-4.15-4.15-10.93-4.14-15.07,0l-24.57,24.57c-4.15,4.15-4.15,10.93,0,15.07l0.24,0.24c4.15,4.15,10.93,4.15,15.07,0l14.52-14.52 l2.26-2.26l2.07-2.07l5.73-5.73C1433.6,180.3,1433.6,173.52,1429.46,169.37z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1238.75,209.82c-2.21-6.13-5.28-11.25-9.2-15.35c-3.92-4.1-8.56-7.21-13.94-9.29 c-5.37-2.09-11.22-3.13-17.53-3.13c-6.83,0-13.18,1.17-19.05,3.5c-5.88,2.34-10.97,5.63-15.26,9.86 c-4.3,4.23-7.68,9.35-10.14,15.35c-2.46,6.01-3.7,12.67-3.7,20c0,7.46,1.24,14.12,3.7,20c2.46,5.87,5.88,10.84,10.24,14.88 c4.36,4.05,9.51,7.18,15.45,9.38c5.94,2.21,12.45,3.32,19.53,3.32c11.57,0,30.63-1.9,38.74-20.5c1.12-2.56,4.46-9.65-3.79-12.54 c-8.57-2.99-11.3,4.7-13.15,6.83c-6.66,7.66-16.3,7.63-21.99,7.63c-3.29,0-6.45-0.57-9.48-1.71c-3.03-1.13-5.75-2.68-8.15-4.64 c-2.4-1.96-4.33-4.3-5.78-7.01c-1.45-2.72-2.31-5.71-2.56-9.01c0-0.01,0-0.03,0-0.04h17.26c0.01,0,0.02,0,0.04,0h2.89v0.04h49.01 c0.12-1.01,0.19-2.02,0.19-3.03c0-1.01,0-2.02,0-3.03C1242.07,223.12,1240.96,215.95,1238.75,209.82z M1180.55,205.28 c4.74-4.1,10.52-6.17,17.35-6.17c3.66,0,6.86,0.61,9.57,1.81c2.72,1.2,4.96,2.81,6.73,4.83c1.77,2.02,3.06,4.36,3.89,7.01 c0.79,2.55,1.19,5.21,1.22,8h-46.58C1173.3,214.47,1175.9,209.3,1180.55,205.28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcuFull);
export default __webpack_public_path__ + "static/media/bcu_full.557a27e22c20a5136590c74a7f77f6ed.svg";
export { ForwardRef as ReactComponent };